// @flow

import React, { PureComponent } from 'react';

import { getPublicAssets } from 'utils/assetsUtils';
import { dynamicClassName } from 'utils/dynamicClassName';

type Props = {
  bonus: number,
  type?: string,
  isDefensive?: boolean,
  classNames?: string,
};

export default class BonusCard extends PureComponent<Props> {
  static defaultProps = {
    bonus: 0,
    isDefensive: false,
    classNames: '',
    type: 'match'
  };

  render() {
    const { bonus, isDefensive, classNames, type } = this.props;
    const blocClassNames = dynamicClassName('block-bonus');
    const bonusType = isDefensive === true ? 'défensif' : 'offensif';
    const iconPath = isDefensive === true ? 'bonus-defense' : 'bonus-offense';
    let wording = '';
    if (type === 'match') {
      wording = !bonus ? 
        <p className='ft-up'>Aucun point de bonus <strong>{bonusType}</strong> obtenu dans ce match</p> :
        <p className='ft-up'>Points de bonus <strong>{bonusType}</strong> remportés dans ce match</p>;
    } else if (type === 'saison') {
      wording = !bonus
        ? <p className='ft-up'>Aucun point de bonus <strong>{bonusType}</strong> obtenu cette saison</p>
        : <p className='ft-up'>Points de bonus <strong>{bonusType}</strong> remportés cette saison</p>;

    }
      
    classNames && blocClassNames.add(classNames);

    return (
      <div className={blocClassNames.build()}>
        <div>
          {bonus !== 0
            ? <span className="number">{bonus}</span>
            : (
              <span>
                <img src={getPublicAssets('/img/svg/zero.svg')} alt='zero' />
              </span>
            )}
          {wording}
        </div>
        <img src={getPublicAssets(`/img/svg/${iconPath}.svg`)} alt="bonus offensif" />
      </div>
    );
  }
}
